import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import OpalFlow from './components/OpalFlow';

function App() {
  return (
    <BrowserRouter>
      <OpalFlow />
    </BrowserRouter>
  );
}

export default App;